import '../css/styleguide.css';
import React from 'react';
import PrimaryButton from './PrimaryButton';

function SocialCard() {
  return (
    <div className='social-card'>
      <p className='social-card__eyebrow'>Follow</p>
      <p className='social-card__intro'>
        Stay connected for updates, reflections, and new work.
      </p>
      <ul className='social-card__list'>
        <li>
          <PrimaryButton
            as='a'
            href='https://www.instagram.com/skysprowles/'
            target='_blank'
            rel='noreferrer'
            label='Instagram'
            tone='light'
            className='social-card__button'
            icon={
              <img
                src={process.env.PUBLIC_URL + '/images/ig.svg'}
                alt=''
                className='social-card__icon'
              />
            }
          />
        </li>
        <li>
          <PrimaryButton
            as='a'
            href='https://www.facebook.com/schuyler.sprowles/'
            target='_blank'
            rel='noreferrer'
            label='Facebook'
            tone='light'
            className='social-card__button'
            icon={
              <img
                src={process.env.PUBLIC_URL + '/images/fb.svg'}
                alt=''
                className='social-card__icon'
              />
            }
          />
        </li>
      </ul>
    </div>
  );
}

export default SocialCard;
